import {
   DateFormatter,
   DateTimeFormatter,
   FontColorContraster,
   OutsideClickDirective,
   PhoneFormatter,
} from '@nxtpeople/nxt-vue-library';
import { App } from 'vue';

function setupDirectives(app: App<Element>) {
   app.directive('outside-click', OutsideClickDirective);
   app.directive('font-color-contrast', FontColorContraster);
   app.directive('date', DateFormatter);
   app.directive('date-time', DateTimeFormatter);
   app.directive('phone', PhoneFormatter);
}

export { setupDirectives };
